import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  class: "common-link-item-icon"
};
const _hoisted_3 = {
  key: 0,
  class: "common-link-item-num"
};
const _hoisted_4 = ["src"];
import { watch, ref, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import { Bridge } from '@/utils/bridge';
import { useLess } from '@/models/hooks';
import constants from '@/constants';
import { couponsDataFun } from '@/views/couponsList/couponsListUtils.js';
import { isLoginAuthenticated, getAppConfig, getQueryString } from '@/utils/common';
import { useStore } from 'vuex';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
import { YourAccount } from '@/assets/marketplaces/cn/configs';
const NUMBER_OF_ROW_ICONS = 3; // Add a new style to a row of three icons
const SPECIAL_JUMP_KEY = 'bestSellingRecommendations'; // Get the path:'Path? templateId=xxx', special handling required

export default {
  __name: 'YACommonLinks',
  props: {
    isLogin: Boolean
  },
  emits: ['update:isLogin'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    useLess('views/yourAccount/components/YACommonLinks.less');
    const router = useRouter();
    const {
      getNcAndRcPromotionsPromise,
      highlightCouponData
    } = couponsDataFun();
    const store = useStore();
    const NOT_AUTHORIZE_LOGIN_PATH = ['businessLicense', 'todayDeal'];
    const {
      APP_PAGE_CONFIG_PAGES_ENUM,
      YA_COMMON_LINKS
    } = constants;
    const yaCommonLinks = ref(YA_COMMON_LINKS);
    const jumpToPage = async item => {
      const routerName = item.PATH;
      if (YourAccount.CLICK_EVENTS_MAPPINGS[routerName]) {
        awsRumHandler.recordClickEvent(clickEvents.yourAccountPage[YourAccount.CLICK_EVENTS_MAPPINGS[routerName]]);
      }
      const imageUrl = item.IMAGEURL;
      const key = item.KEY;
      if (!NOT_AUTHORIZE_LOGIN_PATH.includes(routerName)) {
        await isLoginAuthenticated();
        const isLoginStatus = await isLoginAuthenticated(false);
        emit('update:isLogin', isLoginStatus);
        if (!isLoginStatus) return;
      }
      const query = {};
      if (imageUrl) {
        store.commit('yourAccount/setBusinessLicenseUrl', imageUrl);
      }
      if (key === SPECIAL_JUMP_KEY) {
        const specialRoute = routerName.split('?');
        query.templateId = getQueryString('templateId', routerName);
        router.push({
          name: specialRoute === null || specialRoute === void 0 ? void 0 : specialRoute[0],
          query
        });
      } else {
        router.push({
          name: routerName,
          query
        });
      }
    };
    const totalAvailableCouponsCount = ref(0); // Number of coupons available for use
    const getCouponsCount = async () => {
      await getNcAndRcPromotionsPromise();
      totalAvailableCouponsCount.value = highlightCouponData.value.length;
    };
    const getSettingPageConfig = async () => {
      const configData = await getAppConfig(APP_PAGE_CONFIG_PAGES_ENUM.SETTING_PAGE);
      yaCommonLinks.value.forEach((link, linkIndex) => {
        link.forEach((item, index) => {
          if (configData[item.KEY]) {
            Object.keys(configData[item.KEY]).forEach(key => {
              if (key !== 'name') {
                yaCommonLinks.value[linkIndex][index][key.toUpperCase()] = configData[item.KEY][key];
              }
            });
          }
        });
      });
    };
    onBeforeMount(() => {
      getSettingPageConfig();
      Bridge.registerFn('pageDidAppear', async () => {
        if (!props.isLogin) return;
        getCouponsCount();
      });
    });
    watch(() => props.isLogin, async isLogin => {
      try {
        if (isLogin) {
          getCouponsCount();
        }
      } catch (error) {
        console.error(error);
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yaCommonLinks.value, (link, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass({
            'ya-common-links-area': true,
            'ya-common-links-three': link.length === NUMBER_OF_ROW_ICONS
          })
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link, (item, itemIndex) => {
          return _openBlock(), _createElementBlock("div", {
            key: itemIndex,
            onClick: $event => item.PATH ? jumpToPage(item) : '',
            class: "common-link-item"
          }, [_createElementVNode("div", _hoisted_2, [totalAvailableCouponsCount.value && itemIndex === 0 && index === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(totalAvailableCouponsCount.value), 1)) : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: item.ICON,
            draggable: "false"
          }, null, 8, _hoisted_4))]), _createElementVNode("span", null, _toDisplayString(item.NAME), 1)], 8, _hoisted_1);
        }), 128))], 2);
      }), 128))]);
    };
  }
};